export default function Founder() {
  return (
    <section id="fundadora" className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
          <div className="grid md:grid-cols-5 gap-8 items-center">
            {/* Image */}
            <div className="md:col-span-2 relative">
              <div className="aspect-[3/4] relative overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/cc6bd678d18ffc50c4183b19877d7d27/15c37b8dc1a7966755955699b721de3f.jpeg"
                  alt="Micaela Kon - Fundadora"
                  className="w-full h-full object-cover object-center scale-110"
                  style={{ objectPosition: '60% center' }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent"></div>
              </div>
            </div>

            {/* Content */}
            <div className="md:col-span-3 p-8 md:p-12">
              <div className="mb-6">
                <div className="inline-block bg-accent/10 text-accent px-4 py-2 rounded-lg text-sm font-semibold mb-4">
                  Fundadora
                </div>
                <h2 className="text-4xl font-bold text-primary mb-2">
                  Micaela Kon
                </h2>
              </div>

              <div className="space-y-4 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-accent/10 rounded flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-graduation-cap-line text-accent text-sm"></i>
                  </div>
                  <p className="text-secondary">
                    <strong className="text-primary">Licenciada en Comercialización</strong> en la Universidad Argentina de la Empresa (UADE)
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-accent/10 rounded flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-award-line text-accent text-sm"></i>
                  </div>
                  <p className="text-secondary">
                    <strong className="text-primary">Certificada en Marketing Digital & Inteligencia Artificial</strong> en la Universidad del CEMA (UCEMA)
                  </p>
                </div>
              </div>

              <div className="border-l-4 border-accent pl-6 mb-6">
                <p className="text-lg text-secondary leading-relaxed italic">
                  "Trabajé dentro de equipos comerciales e industrias B2B donde
                  incorporar un nuevo canal digital de ventas fue el despegue que
                  necesitaban en su facturación. Hoy acompaño a empresas en ese mismo
                  proceso de transformación y crecimiento."
                </p>
              </div>

              <p className="text-secondary leading-relaxed">
                Con experiencia en estrategia comercial, marketing digital y
                acompañamiento a empresas B2B, Micaela lidera Rumbo Marketing con una
                visión clara: transformar el marketing en un motor de crecimiento
                medible y sostenible para cada cliente.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
